import { h } from '@stencil/core';

const Icon = ({ width = '1rem', height = 'auto' }) => {
  return (
    <svg width={width} height={height} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 512 512" enable-background="new 0 0 512 512">
      <g>
        <path
          fill="none"
          stroke="#111111"
          stroke-width="20"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          d="
		M451.355,221.605l-36.053-24.037c-3.7-2.469-8.404-2.693-12.337-0.598c-3.915,2.103-6.343,6.151-6.343,10.603v12.021h-31.458
		v-12.021c0-3.218-1.239-6.235-3.508-8.508c-2.262-2.266-5.28-3.517-8.513-3.509h-11.604l-20.425-27.254
		c-2.269-3.013-5.852-4.801-9.618-4.801h-56.08v-0.495h24.033c6.625,0,12.012-13.892,12.012-20.529
		c0-6.651-5.387-12.025-12.012-12.025H175.286c-6.625,0-12.021,5.374-12.021,12.025c0,6.637,5.395,20.529,12.021,20.529h24.042
		v0.495h-36.07c-3.159,0-6.26,1.285-8.488,3.521c-2.236,2.228-3.533,5.333-3.533,8.504v20.03h-24.025
		c-3.151,0-6.268,1.276-8.496,3.517c-2.236,2.236-3.516,5.337-3.516,8.501v44.067H88.652v-44.067
		c0-6.638-5.387-12.017-12.021-12.017s-22.525,5.379-22.525,12.017v116.175c0,6.647,15.891,12.025,22.525,12.025
		s12.021-5.378,12.021-12.025v-44.063H115.2v44.071c0,3.209,1.239,6.223,3.516,8.492c2.27,2.273,5.28,3.516,8.496,3.516h31.083
		l44.557,44.558c2.245,2.265,5.279,3.521,8.488,3.521h141.828c3.208,0,6.226-1.256,8.488-3.521c2.269-2.265,3.508-5.291,3.508-8.5
		v-36.058h31.442l0.016,12.021c-0.016,4.443,2.428,8.5,6.343,10.599c3.916,2.086,8.638,1.87,12.329-0.591l36.062-24.041
		c3.342-2.232,5.362-5.985,5.362-9.996v-92.15C456.717,227.582,454.697,223.829,451.355,221.605z"
        />
      </g>
    </svg>
  );
};

export default Icon;
